import * as React from 'react';
import "./index.scss";
import { Affix, Input, Dropdown, Menu, Layout } from 'antd';
import { requestSearch, requestHint, requestIndustry, userToken, requestUserInfo, logout, requestIndustryByStr } from '../../model/api';
import Results from '../results';
import { parse } from 'query-string';
import chroma from 'chroma-js';
import Login from '../login/login';
import { ReactComponent as HeadSvg } from '../search/images/head.svg';

const { Footer } = Layout;

export default class VC extends React.Component {
  _userMenu = (
    <Menu>
        <Menu.Item key="0">
            <div onClick={this.handleLogout.bind(this)}>退出登陆</div>
        </Menu.Item>
    </Menu>
  );
  _last_q = "";
  _color_scale = chroma.scale(["red", "pink", "orange", "yellow", "green", "blue", "purple"]);
  _color_suggested = chroma("orange")

  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      q: "",
      hints: [],
      hintIndex: -1,
      resultId: null,
      resultTotal: 0,
      resultError: false,
      headerVisible: false,
      industries: [],
      showLogin: false,
      userInfo: null,
      suggested_industry: null
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputKeyDown = this.handleInputKeyDown.bind(this);
    this.backToTop = this.backToTop.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleClickUser = this.handleClickUser.bind(this);
    this.handleLoginClose = this.handleLoginClose.bind(this);
  }

  componentDidMount() {
    this.handleParams();
    if (!this._last_q) {
      requestIndustry().then(data => {
        if (data && data.status == 0) {
          this.setState({ industries: data.data });
        }
      })
    }
    this.requestUserInfo();
  }

  componentDidUpdate() {
    this.handleParams();
  }

  requestUserInfo() {
    if (userToken()) {
      requestUserInfo(userToken()).then(data => {
        if (data.data && data.data.length) {
          let result = data.data[0];
          if (result.succeed && result.items && result.items.length) {
            this.setState({ userInfo: result.items[0] })
          }
        }
      })
    }
  }

  handleLogout() {
    logout();
    this.setState({ userInfo: null })
  }

  handleParams() {
    let params = parse(this.props.location.search);
    let q = params.q;
    if (q && q != this._last_q) {
      this._last_q = q;
      this.backToTop();
      this.setState({ q });
      this.handleSearch(q);
    }else if(this._last_q && !q) {
      this._last_q = q
      this.setState({inited: false, resultId: null, resultCount: 0, q: "", suggested_industry: null});
    }
  }

  backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  handleInputChange(e) {
    let q = e.target.value;
    this.setState({ q });
    if (q) {
      requestHint(q).then(data => {
        if (data && data.status == 0) {
          this.setState({ hints: data.data, hintIndex: -1 });
        }
      })
    } else {
      this.setState({ hints: [], hintIndex: -1 });
    }
  }

  handleInputKeyDown(e) {
    if (this.state.hints.length) {
      switch (e.keyCode) {
        case 38:
          if (this.state.hintIndex > 0) {
            let index = this.state.hintIndex - 1;
            let q = this.state.hints[index].search_term;
            this.setState({ hintIndex: index, q });
          }
          break;
        case 40:
          if (this.state.hintIndex < this.state.hints.length - 1) {
            let index = this.state.hintIndex + 1;
            let q = this.state.hints[index].search_term;
            this.setState({ hintIndex: index, q });
          }
          break;
      }
    }
  }

  handleSearch(q) {
    if (q) {
      this.setState({ hints: [], resultId: null, resultTotal: 0, inited: true, suggested_industry: null });
      requestSearch({
        search_type: "adv",
        resp_type: "json",
        abstract: q,
        title: "",
        keywords: [],
        trans_kw: "zh2en",
        filter: {
          region: [],
          levels: []
        }
      }).then(data => {
        if (data && data.status == 0) {
          this.setState({ resultId: data.data.id, resultTotal: data.data.experts, resultError: false, hints: [] });
        } else {
          this.setState({ resultError: true, hints: [] })
        }
      })
      requestIndustryByStr(q).then(data => {
        if(data && data.status == 0 && Object.keys(data.data).length != 0) {
          this.setState({suggested_industry: data.data})
        }
      })
    }
  }

  handleClickSearch(q) {
    q = q || this.state.q;
    if (q) {
      this._last_q = "";
      this.props.history.push(`/vc?q=${q}`);
    }
  }

  handleClickUser(e) {
    if (!this.state.userInfo) {
        this.setState({showLogin: true})
    }
    e.stopPropagation();
  }

  handleLoginClose() {
    this.requestUserInfo();
    this.setState({ showLogin: false });
  }

  render() {
    const { userInfo } = this.state;
    return (
      <div className='vc'>
        {this.state.headerVisible && (
          <div className='vc-header' />
        )}
        <div className='vc-user'>
          <Affix offsetTop={0} >
            {
              userInfo ? (
                <Dropdown overlay={this._userMenu} trigger={['click']}>
                  <div className='user' onClick={this.handleClickUser}>
                    <div className='img'>
                      {userInfo && userInfo.img ? <img src={userInfo.img} /> : <HeadSvg />}
                    </div>
                  </div>
                </Dropdown>
              ) : (
                  <div className='user' onClick={this.handleClickUser}>
                    <div className='img'>
                      {userInfo && userInfo.img ? <img src={userInfo.img} /> : <HeadSvg />}
                    </div>
                  </div>
                )
            }
          </Affix>
        </div>
        <div className='vc-content'>
          <div className='vc-logo' onClick={() => this.props.history.push(`/vc`)}>{this.props.title}</div>
          <Affix offsetTop={0} onChange={b => this.setState({ headerVisible: b })}>
            <div className='vc-search'>
              <div className='vc-input-box'>
                <Input
                  className='vc-input'
                  placeholder="请输入关键词"
                  value={this.state.q}
                  onChange={this.handleInputChange}
                  onKeyDown={this.handleInputKeyDown}
                  onPressEnter={() => this.handleClickSearch()} />
                <i className='fa fa-search' onClick={() => this.handleClickSearch()} />
                {!!this.state.hints.length && (
                  <div className='vc-hints'>
                    {this.state.hints.map((data, i) => {
                      let label = `${data.name_zh}${data.parents && data.parents.length ? " (" + data.parents[0].name_zh + ")" : ""}`
                      return <div
                        className='vc-hint'
                        key={i}
                        style={i == this.state.hintIndex ? { backgroundColor: "#96cdf666" } : undefined}
                        onClick={() => this.handleClickSearch(data.search_term)} >
                        {label}
                      </div>
                    })}
                  </div>
                )}
              </div>
            </div>
          </Affix>
          {
            !this.state.inited && !!this.state.industries.length && (
              <div className='vc-industries'>
                {this.state.industries.map((industry, i) => {
                  let color = this._color_scale(i * 0.08).luminance(0.24).hex();
                  return <div className='vc-industry' key={i}>
                    <div className='vc-industry-title' style={{ color }} onClick={() => this.handleClickSearch(industry.search_term)}>{industry.name_zh}<span>{">"}</span></div>
                    <div className='vc-industry-children'>
                      {industry.children.map((child, ci) => {
                        return <div className='vc-industry-child' key={ci} onClick={() => this.handleClickSearch(child.search_term)}>
                          <i className='fa fa-sitemap' style={{ color }} />{child.name_zh}
                        </div>
                      })}
                      <div className='vc-industry-child-empty' />
                      <div className='vc-industry-child-empty' />
                      <div className='vc-industry-child-empty' />
                    </div>
                  </div>
                })}
              </div>
            )
          }
          {
            this.state.inited && this.state.suggested_industry && (
              <div className='vc-suggested-industry'>
                <div className='vc-suggested-industry-title'>产业链信息:
                  <span 
                    style={{fontWeight: "bold", marginLeft: "8px", color: this._color_suggested.hex(), userSelect: "none", cursor: "pointer"}}
                    onClick={() => this.handleClickSearch(this.state.suggested_industry.search_term)}>
                      {this.state.suggested_industry.name_zh}
                  </span>
                </div>
                <div className='vc-suggested-industry-children'>
                  {this.state.suggested_industry.children.map((child, i) => {
                    return (
                      <div 
                        className='vc-suggested-industry-child' 
                        key={i} 
                        style={this._last_q == child.search_term ? {backgroundColor: "#fbe8c3"} : undefined}
                        onClick={this._last_q == child.search_term ? undefined : () => this.handleClickSearch(child.search_term)}>
                        {child.name_zh}
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          }
          <div className='vc-results'>
            {this.state.inited && <Results
              id={this.state.resultId}
              total={this.state.resultTotal}
              error={this.state.resultError}
              onShowLogin={() => this.setState({ showLogin: true })}
              onPageChange={() => this.backToTop()} />}
          </div>
        </div>
        <div style={{width: '100%', height: "120px"}} />
        <Footer className='footer-con'><div className='footer'>© 2005-2020 AMiner 京ICP备17059297号-2</div></Footer>
        {this.state.showLogin && <Login onClose={this.handleLoginClose} />}
      </div>
    )
  }
}